import { TriangleDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Flex,
  GridItem,
  GridItemProps,
  Heading,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Spacer,
} from "@chakra-ui/react";
import React, { FC } from "react";

export interface GridCardProps extends GridItemProps {
  title: string;
  json?: unknown;
  variant?: "onecolumn" | "twocolumns";
}

export const GridCard: FC<GridCardProps> = ({
  title,
  json,
  variant = "onecolumn",
  children,
  ...rest
}) => {
  return (
    <>
      <GridItem marginRight="1rem" marginTop="1rem" {...rest}>
        <Flex>
          <Heading size="md" textTransform="uppercase" color="brand.analytic">
            {title}
          </Heading>
          <Spacer />
          <Box>
            {json ? (
              <Popover>
                <PopoverTrigger>
                  <IconButton
                    icon={<TriangleDownIcon />}
                    aria-label="JSON"
                    title="JSON"
                    variant="outline"
                    background="white"
                    size="xs"
                    marginRight="1rem"
                  />
                </PopoverTrigger>
                <PopoverContent width="600px">
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverHeader>JSON content</PopoverHeader>
                  <PopoverBody>
                    <pre>{JSON.stringify(json, null, 2)}</pre>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            ) : null}
          </Box>
        </Flex>
        {variant === "onecolumn" ? children : null}
      </GridItem>
      {variant === "twocolumns" ? (
        <GridItem {...rest} marginTop="1rem">
          {children}
        </GridItem>
      ) : null}
    </>
  );
};
